import styled from 'styled-components'
import { colors } from '../tokens'

export const Wrapper = styled.div`
  position: relative;
  min-width: 0;
`

export const Content = styled.div`
  overflow-x: auto;
  overflow-y: hidden;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }

  &:focus-visible {
    outline: 2px solid ${colors.primary};
    outline-offset: -2px;
  }

  @media print {
    overflow: visible;
  }
`

export const Bar = styled.div`
  position: sticky;
  bottom: 0;
  z-index: 3;
  height: 14px;
  overflow-x: auto;
  overflow-y: hidden;
  background: ${colors.white};
  border-top: 1px solid ${colors.border};
  scrollbar-width: thin;
  scrollbar-color: ${colors.ink400} ${colors.accent};

  &::-webkit-scrollbar {
    height: 10px;
  }

  &::-webkit-scrollbar-track {
    background: ${colors.accent};
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 5px;
    background: ${colors.ink400};
  }

  @media print {
    display: none;
  }
`

export const Spacer = styled.div`
  height: 1px;
`
